import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { useApiClient } from "../../../apiClient";
import { CourtRecordingDto } from "../../../models/court-recording/dto/court-recording.dto";
import { GET_COURT_RECORDINGS_QUERY_KEY } from "./useListCourtRecordings";
import { translate } from "../../../i18n";

export const useCreateCourtRecording = (
    organizationId: string,
    onSuccess?: (data: CourtRecordingDto) => void,
) => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationKey: ['createCourtRecording'],
        mutationFn: ({ file, courtId, gameId }: { file: File; courtId: number; gameId?: number }) => {
            const formData = new FormData();
            formData.append('video', file);
            formData.append('courtId', String(courtId));
            if (gameId) formData.append('gameId', String(gameId));

            return client.fetchApiWithFormData<CourtRecordingDto>({
                endpoint: `court-recordings?organizationId=${organizationId}`,
                method: 'POST',
                formData,
            });
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: GET_COURT_RECORDINGS_QUERY_KEY(organizationId) });
            onSuccess?.(data);
        },
        onError: (err) => {
            toast({
                title: translate('court_recording.upload_failed'),
                description: err instanceof Error ? err.message : undefined,
                status: 'error',
            });
        },
    });
};
